module.exports = __webpack_public_path__ + "static/media/BLUE.703a3f34.png";